module.exports = __webpack_public_path__ + "dimer/static/img/DrRT.7b6124e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DrRT.jpg
// module id = Ygg8
// module chunks = 0